import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { FiShoppingCart } from 'react-icons/fi';

const CartButton = styled.button`
  padding: 0;
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  border: none;
  border-radius: 50%;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  position: fixed;
  bottom: 100px;
  right: 30px;
  z-index: 999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 24px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(212, 175, 55, 0.4);
  }

  @media (max-width: 768px) {
    bottom: 100px;
    right: 20px;
  }
`;

const CartBadge = styled.span`
  position: absolute;
  top: -8px;
  right: -8px;
  background: #e74c3c;
  color: #fff;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

const GlobalCartButton = () => {
  const [cart, setCart] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const loadCart = () => {
      const savedCart = sessionStorage.getItem('orderCart');
      if (savedCart) {
        try {
          setCart(JSON.parse(savedCart));
        } catch (e) {
          setCart([]);
        }
      } else {
        setCart([]);
      }
    };

    loadCart();

    const handleStorageChange = () => {
      loadCart();
    };

    window.addEventListener('storage', handleStorageChange);
    const interval = setInterval(loadCart, 500);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  const handleClick = () => {
    if (location.pathname === '/select-items') {
      // Trigger cart sidebar to open by dispatching a custom event
      window.dispatchEvent(new CustomEvent('openCart'));
    } else {
      navigate('/select-items');
    }
  };

  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);

  if (location.pathname === '/place-order') {
    return null;
  }

  return (
    <CartButton onClick={handleClick}>
      <FiShoppingCart />
      {totalItems > 0 && <CartBadge>{totalItems}</CartBadge>}
    </CartButton>
  );
};

export default GlobalCartButton;
